import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";
import workspace from "../../core/workspace";
import {createWallFromPointsV2} from "../../../../helpers/freeDrawHelper";
import PointV2 from "../../core/shapes/pointV2";


export class WallsController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.walls;
  }

  getWallByPoint(searchPoint) {
    return workspace.walls.find(wall => {
      for (const wallPoint of wall.getPoints()) {
        if (wallPoint.id === searchPoint.id) {
          return wall
        }
      }
    })
  }

  importData(data) {
    workspace[this.resourceName] = [];
    for (let resource of data) {
      const points = resource.addedPoints.map(pointData => {
        const pointV2 = new PointV2(pointData.x, pointData.y, workspace, pointData.params, pointData.design);
        pointV2.importData(pointData);

        return pointV2
      });
      createWallFromPointsV2(points, resource.centerPoint, resource.lockedAngleStep);
    }
  }

}

